import { callable } from './callable'
import type { ChartResult, ChartSpec } from '../types/chart'

export interface RunChartQueryInput {
  workspaceId: string
  chartId?: string
  spec?: ChartSpec
  refresh?: boolean
}

export async function runChartQuery(input: RunChartQueryInput): Promise<ChartResult> {
  return callable<RunChartQueryInput, ChartResult>('runChartQuery', input)
}

export interface ListChartFieldValuesInput {
  workspaceId: string
  dataset: string
  field: string
  query?: string
  limit?: number
}

export interface ChartFieldValueItem {
  value: string | number | boolean
  label?: string
  labelKey?: string
}

export interface ListChartFieldValuesOutput {
  values: ChartFieldValueItem[]
  truncated: boolean
}

export async function listChartFieldValues(
  input: ListChartFieldValuesInput,
): Promise<ListChartFieldValuesOutput> {
  return callable<ListChartFieldValuesInput, ListChartFieldValuesOutput>('listChartFieldValues', input)
}

